import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import Header from "examples/Header"
import calendarStyles from "./style"
import { useState } from "react"
import moment from "moment"
import InfoIcon from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import { RoleLabel, Role } from "constant/Role"
import TeacherManagementCalendar from "components/TeacherManagementCalendar/TeacherManagementCalendar"
import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
import MonthCalendar from "pages/calendar/components/MonthCalendar"

function TeacherManagementCalendarSection(props) {
  const { tab, setTab } = props
  const [start, setStart] = useState(
    moment().startOf("isoWeek").weekday(1).format("YYYY-MM-DD")
  )
  const [end, setEnd] = useState(
    moment().startOf("isoWeek").weekday(7).format("YYYY-MM-DD")
  )
  const auth = useSelector(selectAuth)
  const [selectedTeacher, setSelectedTeacher] = useState(null)

  return (
    <Grid
      container
      columnSpacing={2}
      rowGap={2}
      className="calendar-teacher-management"
    >
      <Grid item xs={12} xl>
        <TeacherManagementCalendar
          outerDate={start}
          selectedTeacher={selectedTeacher}
          setSelectedTeacher={setSelectedTeacher}
          tab={tab}
          setTab={setTab}
          start={start}
          end={end}
          setStart={setStart}
          setEnd={setEnd}
        />
      </Grid>
      <Grid
        item
        xs={12}
        xl="auto"
        mb={{ xs: 3, xl: 0 }}
        sx={({ breakpoints }) => ({
          [breakpoints.down(1294)]: {
            width: "100%",
          },
        })}
      >
        <MonthCalendar
          start={start}
          setStart={setStart}
          end={end}
          setEnd={setEnd}
          isTeacherLXO={true}
          selectedTeacher={selectedTeacher}
        />
      </Grid>
    </Grid>
  )
}

export default TeacherManagementCalendarSection
